import React from 'react';

import useCheckoutState from '../../hooks/useCheckoutState';
import clsx from 'clsx';
import StyledElement from '@repo/checkout/components/StyledElement';

const PaymentOptions = () => {
  const { checkout, paymentOption, setPaymentOption, setSelectedPaymentMethod } =
    useCheckoutState();

  const enabledOptions = checkout.paymentOptions?.filter(option => option.enabled);

  const hasNoPaymentOptions = enabledOptions.length === 0;
  const isOnlyFullPayment = enabledOptions.length === 1 && enabledOptions[0].type === 'full';

  if (hasNoPaymentOptions || isOnlyFullPayment) {
    return null;
  }

  const visibleOptions = enabledOptions.filter(option => option.showPaymentButton);

  return (
    <div className="cp_payment-options-wrapper">
      {visibleOptions.length > 0 && (
        <div className="cp_payment-options-container flex flex-row gap-2 mb-2">
          {visibleOptions.map(option => {
            const isSelected = paymentOption.type === option.type;

            return (
              <StyledElement
                elementPath={`checkout.form.manualPayments`}
                selectedElementPath={`checkout.form.manualPayments.selectedStyles`}
                isSelected={isSelected}
                as="button"
                key={option.type}
                type="button"
                onClick={() => {
                  setPaymentOption(option);

                  if (option.type === 'manual') {
                    setSelectedPaymentMethod('manual');
                  } else {
                    setSelectedPaymentMethod('card');
                  }
                }}
                className={clsx(
                  `cp_payment-option cp_payment-option--${option.type}`,
                  'focus:outline-none w-full flex flex-col border-solid',
                  // Default styles
                  isSelected
                    ? [
                        'bg-[var(--cp_checkout-form-manualPayments-selected-background-color)]',
                        'text-[var(--cp_checkout-form-manualPayments-selected-color)]',
                        'border-[var(--cp_checkout-form-manualPayments-selected-border-color)]',
                      ]
                    : [
                        'bg-[var(--cp_checkout-form-manualPayments-background-color)]',
                        'text-[var(--cp_checkout-form-manualPayments-color)]',
                        'border-[var(--cp_checkout-form-manualPayments-border-color)]',
                      ],
                  '[border-width:var(--cp_checkout-form-manualPayments-border-width)]',
                  // Layout styles
                  'rounded-[var(--cp_checkout-form-manualPayments-border-radius)]',
                  'p-[var(--cp_checkout-form-manualPayments-padding)]',
                  // Focus styles (use selected styles)
                  'focus:bg-[var(--cp_checkout-form-manualPayments-selected-background-color)]',
                  'focus:border-[var(--cp_checkout-form-manualPayments-selected-border-color)]',
                  'focus:text-[var(--cp_checkout-form-manualPayments-selected-color)]',
                  {
                    'cp_payment-option--selected z-10 ring-1 ring-[var(--cp_checkout-form-manualPayments-selected-border-color)]':
                      isSelected,
                  },
                )}
              >
                <div className="cp_payment-option-content text-left flex flex-col h-full">
                  <StyledElement
                    elementPath="checkout.form.manualPayments.name"
                    className={clsx(
                      'cp_payment-option-name',
                      'bg-[var(--cp_checkout-form-manualPayments-name-background-color)]',
                      'text-[var(--cp_checkout-form-manualPayments-name-color)]',
                      '[font-family:var(--cp_checkout-form-manualPayments-name-font-family)]',
                      '[font-style:var(--cp_checkout-form-manualPayments-name-font-style)]',
                      '[font-size:var(--cp_checkout-form-manualPayments-name-font-size)]',
                      '[line-height:var(--cp_checkout-form-manualPayments-name-line-height)]',
                      '[font-weight:var(--cp_checkout-form-manualPayments-name-font-weight)]',
                    )}
                  >
                    {option.name}
                  </StyledElement>
                  <StyledElement
                    elementPath="checkout.form.manualPayments.description"
                    className={clsx(
                      'cp_payment-option-description',
                      'bg-[var(--cp_checkout-form-manualPayments-description-background-color)]',
                      'text-[var(--cp_checkout-form-manualPayments-description-color)]',
                      '[font-family:var(--cp_checkout-form-manualPayments-description-font-family)]',
                      '[font-style:var(--cp_checkout-form-manualPayments-description-font-style)]',
                      '[font-size:var(--cp_checkout-form-manualPayments-description-font-size)]',
                      '[line-height:var(--cp_checkout-form-manualPayments-description-line-height)]',
                      '[font-weight:var(--cp_checkout-form-manualPayments-description-font-weight)]',
                    )}
                  >
                    {option.description}
                  </StyledElement>
                </div>
              </StyledElement>
            );
          })}
        </div>
      )}

      {paymentOption.instructions && (
        <div className="cp_payment-option-instructions-wrapper">
          <StyledElement
            elementPath="checkout.form.manualPayments.instructions"
            className={clsx(
              'cp_payment-option-instructions',
              'bg-[var(--cp_checkout-form-manualPayments-instructions-background-color)]',
              'text-[var(--cp_checkout-form-manualPayments-instructions-color)]',
              '[font-family:var(--cp_checkout-form-manualPayments-instructions-font-family)]',
              '[font-style:var(--cp_checkout-form-manualPayments-instructions-font-style)]',
              '[font-size:var(--cp_checkout-form-manualPayments-instructions-font-size)]',
              '[line-height:var(--cp_checkout-form-manualPayments-instructions-line-height)]',
              '[font-weight:var(--cp_checkout-form-manualPayments-instructions-font-weight)]',
            )}
          >
            {paymentOption.instructions}
          </StyledElement>
        </div>
      )}
    </div>
  );
};

export default PaymentOptions;
